import { jsonIf } from '../utils/utils.network';

export const fetchQuestions = async ({ yearId, makeId, modelId, trimId, colorId, transmissionId, engineId, drivetrainId, vin = '', mileage }) => {
  const body = JSON.stringify({
    vehicle: {
      yearId,
      makeId,
      modelId,
      trimId,
      colorId,
      transmissionId,
      engineId,
      drivetrainId,
      vin,
    },
    mileage,
    contactInfo: {},
    isConsumerOffer: true,
    channelId: process.env.CHANNEL_ID,
    vehicleBuildDataFlags: {
      cadsUsed: false,
      transmissionsVinVerified: false,
      enginesVinVerified: false,
      drivetrainsVinVerified: false,
      optionsVinVerified: false,
      colorsVinVerified: false,
    },
  });

  try {
    const response = await fetch(`${process.env.BASE_URL}/${process.env.V_PREFIX}/documents?api_key=${process.env.API_KEY}`, {
      method: 'POST',
      headers: {
        authorization: `Basic ${process.env.ICO_TOKEN}`,
        QuestionConversion: 'fury',
      },
      body,
      redirect: 'follow',
      mode: 'cors',
    });
    const result = await jsonIf(response);
    return {
      questionsGroupedByCanonical: result.data.documents,
      answers: result.data.wipReadback.answers,
      trimInformation: result.data.trimInformation,
      vehicleInformationResponse: result.data.vehicleInformationResponse,
    };
  } catch (error) {
    console.log('error', error);
  }
};

export default { fetchQuestions };
